module.exports = __webpack_public_path__ + "static/media/stripe.d936a023.svg";